import { useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { eur } from "@/lib/format";
import { Modal, Field, inputCls, useAsync } from "./ui";

export function PaymentModal({ invoice, onClose, onDone }) {
  const due = Number(invoice.totals?.net_a_payer ?? invoice.totals?.total_ttc) - Number(invoice.montant_paye || 0);
  const [form, setForm] = useState({ montant: due.toFixed(2), date: new Date().toISOString().slice(0, 10), mode: "virement", reference: "" });
  const { busy, run } = useAsync();
  const save = () => run(async () => {
    try {
      const { data } = await api.post("/billing/payments", { invoice_id: invoice.id, ...form, montant: Number(form.montant) });
      toast.success(`Paiement enregistré — facture ${data.invoice_status === "payee" ? "payée" : "partiellement payée"}`); onDone();
    } catch (e) { toast.error(e?.response?.data?.detail || "Erreur"); }
  });
  return (
    <Modal title="Enregistrer un paiement" subtitle={`Facture ${invoice.numero} · reste à payer ${eur(due, "always")}`} onClose={onClose} testId="payment-modal">
      <div className="grid sm:grid-cols-2 gap-3">
        <Field label="Montant reçu (€)"><input type="number" step="0.01" data-testid="pay-montant" className={inputCls} value={form.montant} onChange={e => setForm({ ...form, montant: e.target.value })} /></Field>
        <Field label="Date"><input type="date" className={inputCls} value={form.date} onChange={e => setForm({ ...form, date: e.target.value })} /></Field>
        <Field label="Mode"><select className={inputCls} value={form.mode} onChange={e => setForm({ ...form, mode: e.target.value })}>{["virement", "cheque", "especes", "carte", "autre"].map(m => <option key={m} value={m}>{m}</option>)}</select></Field>
        <Field label="Référence"><input className={inputCls} value={form.reference} onChange={e => setForm({ ...form, reference: e.target.value })} /></Field>
      </div>
      <button data-testid="pay-save" disabled={busy} onClick={save} className="btn-primary w-full justify-center mt-5">Enregistrer</button>
    </Modal>
  );
}

export function CreditNoteModal({ invoice, onClose, onDone }) {
  const [form, setForm] = useState({ pct: "", amount_ht: "", motif: "" });
  const { busy, run } = useAsync();
  const save = () => run(async () => {
    try {
      const body = { invoice_id: invoice.id, motif: form.motif };
      if (form.pct !== "") body.pct = Number(form.pct); else body.amount_ht = Number(form.amount_ht);
      const { data } = await api.post("/billing/credit-notes", body);
      toast.success(`Avoir ${data.numero} émis (${eur(Math.abs(data.totals.total_ttc))} TTC)`); onDone();
    } catch (e) { toast.error(e?.response?.data?.detail || "Erreur"); }
  });
  return (
    <Modal title="Émettre un avoir" subtitle={`Sur la facture ${invoice.numero} — ${eur(invoice.totals?.total_ttc)} TTC. Une facture émise ne se modifie pas : elle se corrige par avoir.`} onClose={onClose} testId="credit-modal">
      <div className="grid sm:grid-cols-2 gap-3">
        <Field label="Pourcentage de la facture" hint="ou"><input type="number" min="0" max="100" step="0.01" data-testid="cn-pct" className={inputCls} value={form.pct} onChange={e => setForm({ ...form, pct: e.target.value, amount_ht: "" })} placeholder="Ex : 25" /></Field>
        <Field label="Montant HT"><input type="number" step="0.01" data-testid="cn-amount" className={inputCls} value={form.amount_ht} onChange={e => setForm({ ...form, amount_ht: e.target.value, pct: "" })} /></Field>
      </div>
      <Field label="Motif (obligatoire, visible sur l'avoir)"><input data-testid="cn-motif" className={inputCls} value={form.motif} onChange={e => setForm({ ...form, motif: e.target.value })} /></Field>
      <button data-testid="cn-save" disabled={busy || !form.motif || (form.pct === "" && form.amount_ht === "")} onClick={save} className="btn-primary w-full justify-center mt-5 disabled:opacity-50">Émettre l'avoir</button>
    </Modal>
  );
}
